module.exports = __webpack_public_path__ + "img/GAME_BADUK1.d49f6f88.jpg";